import { render, staticRenderFns } from "./AddDependent.vue?vue&type=template&id=72537390&scoped=true&"
import script from "./AddDependent.vue?vue&type=script&lang=js&"
export * from "./AddDependent.vue?vue&type=script&lang=js&"
import style0 from "./AddDependent.vue?vue&type=style&index=0&id=72537390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72537390",
  null
  
)

component.options.__file = "AddDependent.vue"
export default component.exports